module.exports = __webpack_public_path__ + "img/purple_rule_ar.370cef81.png";